export  const formateTipo = (value, flgTitularDependente = null) => {

    if(flgTitularDependente)
        return 'Funcionário/Dependente'
    const tipo = [
        { key: 1,  value:'Funcionário'},
        { key: 2 , value: 'Dependente'},
        { key: 3 , value: 'Comunidade'},
        { key: 4 , value: 'Terceiros'},
    ];

    let result = tipo.find( (elem) => elem.key == value)

    if(result) 
        return result.value
    
    return "";
}

export  const formateDate = (value) => {
    if(!value)
    {
        return ""
    }
    let date = new Date(value);
    let day = date.getDate();
    let month = (date.getMonth()+1);
    return (day > 9 ? day : '0'+day) +'/'+ (month > 9 ? month : '0'+month) +'/'+ date.getFullYear() 
}

export  const formateHours = (value) => {
    if(!value)
    {
        return ""
    }
    let date = new Date(value);
    let hours = date.getHours() > 9 ? date.getHours() : '0'+date.getHours()
    let minutes =  date.getMinutes() > 9 ?  date.getMinutes() :  '0'+date.getMinutes()
    return hours + ':' + minutes
}

export const getStatusOptions = () => { 
    return [ 
        { value: null, text: '(Selecione)'},
        { value: 1,  text:'Ativo'},
        { value: 2 , text: 'Inativo'},
    ] 
};

export const getSexoOptions = () => {
    return [
        { value: null, text: '(Selecione)'},
        { value:'M', text:'MASCULINO'},
        { value:'F', text:'FEMININO'},
        { value:'N', text:'NÃO DESEJO INFORMAR'}
    ]
}


export const getParentescoOptions = () => {
    return [
        { value: 1, text: "CONJUGE/COMPANHEIRO(A)" },
        { value: 2, text: "FILHO(A)" },
        { value: 4, text: "ENTEADO(A)" },
        { value: 5, text: "DESCENDENTE" },
        { value: 6, text: "ASCENDENTE" },
        { value: 7, text: "IRMAO/IRMA" },
        { value: 8, text: "MENOR SOB DEPENDENCIA" },
        { value: 9, text: "MENOR SOB GUARDA" },
        { value: 10, text: "PAI/MAE" },
        { value: 11, text: "MENOR SOB TUTELA" },
        { value: 12, text: "EX-CONJUGE DIV. C/PENSAO" },
        { value: 13, text: "SOGRO(A)" },
        { value: 14, text: "OUTROS" },
        { value: 15, text: "SOBRINHO(A)"}
    ]
}

export const getParentescoOptions2 = () => {
    return [
        { value: "CONJUGE/COMPANHEIRO(A)", text: "CONJUGE/COMPANHEIRO(A)" },
        { value: "FILHO(A)", text: "FILHO(A)" },
        { value: "ENTEADO(A)", text: "ENTEADO(A)" },
        { value: "DESCENDENTE", text: "DESCENDENTE" },
        { value: "ASCENDENTE", text: "ASCENDENTE" },
        { value: "IRMAO/IRMA", text: "IRMAO/IRMA" },
        { value: "MENORSOBDEPENDENCIA", text: "MENOR SOB DEPENDENCIA" },
        { value: "MENORSOBGUARDA", text: "MENOR SOB GUARDA" },
        { value: "PAI/MAE", text: "PAI/MAE" },
        { value: "MENORSOBTUTELA", text: "MENOR SOB TUTELA" },
        { value: "EX-CONJUGEDIV.C/PENSAO", text: "EX-CONJUGE DIV. C/PENSAO" },
        { value: "SOGRO(A)", text: "SOGRO(A)" },
        { value: "OUTROS", text: "OUTROS" },
        { value: "SOBRINHO(A)", text: "SOBRINHO(A)"}
    ]
}


export const getTipoOptions = () => {
    return [
        { value: null, text: '(Selecione)'},
        { value: 1,  text:'Funcionário'},
        { value: 2 , text: 'Dependente'},
    ]
}

export const getTipoOptions2 = () => {
    return [
        { value: null, text: '(Selecione)'},
        { value: "TITULAR",  text:"TITULAR"},
        { value: "DEPENDENTE" , text: "DEPENDENTE"},
    ]
}

export const getEstadoCivilOptions = () => {
    return [
        { value: null, text: '(Selecione)'},
        { value: "1",  text:"Solteiro(a)"},
        { value: "2" , text: "Casado(a)"},
        { value: "3" , text: "Viúvo(a)"},
        { value: "4" , text: "Divorciado(a)"},
        { value: "5" , text: "Não desejo Informar"},
    ]
}

export const getEstadoCivilOptions2 = () => {
    return [
        { value: null, text: '(Selecione)'},
        { value: "Solteiro(a)",  text:"Solteiro(a)"},
        { value: "Casado(a)" , text: "Casado(a)"},
        { value: "Viúvo(a)" , text: "Viúvo(a)"},
        { value: "Divorciado(a)" , text: "Divorciado(a)"},
        { value: "Não desejo Informar" , text: "Não desejo Informar"},
    ]
}

export const addZero = (str, size = 11) =>
{
    if(str == null)
        return str
    
    let numbers = str.replace(/\D/g, '');

    if(numbers != null && numbers != "") {
        if(numbers.trim().length < size) {
            numbers = "0" + numbers.trim()
        }
    }
    return numbers
}


export const addErrors = (row, key, message = null) => {
    if (!row.errors) {
        row.errors = {fieldErrors: [], success: false}
    } else if (typeof row.errors === 'string') {
        row.errors = JSON.parse(row.errors)
    }
    if(!message)
        message = "Campo obrigatório"
    if (!row.errors.fieldErrors[key]) {
        row.errors.fieldErrors[key] = []
    }
    row.errors.fieldErrors[key].push(message)
    return row
}